import { INDEX, TVNZ_STATION } from './types';

const getStationLoading = (
  stationLoadingSheet: Array<Array<any>>,
  demographic: any,
  station: TVNZ_STATION,
  input: number
) => {
  return getLoading(stationLoadingSheet, demographic, station, input);
};

const getLoading = (
  pricingSheet: Array<Array<any>>,
  demographic: any,
  station: string,
  input: number
): number => {
  if (pricingSheet.length === 0) return 0;

  const rowIndex = getRowIndex(pricingSheet, demographic, station);
  const columnIndex = getColumnIndex(pricingSheet, input);
  return pricingSheet[rowIndex][columnIndex];
};

const getRowIndex = (
  pricingSheet: Array<Array<any>>,
  demographic: any,
  station: string
): number => {
  return pricingSheet.findIndex(
    (row: Array<any>) =>
      row[INDEX.DEMOGRAPHIC] === demographic && row[INDEX.RATECARD] === station
  );
};

const getColumnIndex = (
  pricingSheet: Array<Array<any>>,
  input: number
): number => {
  return pricingSheet[INDEX.HEADER_ROW].indexOf(input);
};

export default getStationLoading;
